import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, statusTypesData } from "@/data";
import { editRevenueReportMutation } from "@/graph";
import { openAlert, setRefetchRevenueReportsList, toggleRevenueReportDrawer } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditRevenueReport = (id, setId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [editRevenueReportAction, { loading }] = useMutation(editRevenueReportMutation);

    const editRevenueReport = async ({ artist, label, release, revenue }) => {
        try {
            await editRevenueReportAction({
                onCompleted: () => {
                    dispatch(setRefetchRevenueReportsList(true));

                    dispatch(toggleRevenueReportDrawer(false));

                    setId(null);

                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", { entity: t("revenueReports.entity") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    data: {
                        ...(release?.albumNameAr && {
                            album_name_ar: { set: release?.albumNameAr },
                        }),
                        ...(release?.upc && {
                            upc: { set: release?.upc },
                        }),
                        ...(release?.label && {
                            album_name_en: { set: release?.label },
                        }),
                        ...(artist?.nameAr && {
                            artist_name_ar: { set: artist?.nameAr },
                        }),
                        ...(artist?.label && {
                            artist_name_en: { set: artist?.label },
                        }),
                        ...(label && {
                            labelName: { set: label },
                        }),
                        ...(revenue && {
                            revenue: { set: parseFloat(revenue) },
                        }),
                    },
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editRevenueReport,
        loading,
    };
};

export default useEditRevenueReport;
